module.exports = __webpack_public_path__ + "img/calendar.1376714c.svg";